import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import logo from './logo.png'; // Ensure the path to logo is correct
import umamilogo from './formula.png';
const NavigationBar = () => {
  return (
    <Navbar expand="lg" className="navbar-custom" fixed="top">
      <Container>
        <Navbar.Brand as={NavLink} to="/">
          <img
            src={umamilogo}
            width="30"
            height="30"
            className="d-inline-block align-top"
            alt="UmamiPredict logo"
          />
          &nbsp;<span className="brand-text">UmamiPredict</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link as={NavLink} exact to="/" className="nav-link-custom">🏡 Home </Nav.Link>
            <Nav.Link as={NavLink} to="/about" className="nav-link-custom">📖 About </Nav.Link>
            <Nav.Link as={NavLink} to="/umami-predictor" className="nav-link-custom">🔮 Predict </Nav.Link>
            {/* <Nav.Link as={NavLink} to="/search" className="nav-link-custom">🔎 Search </Nav.Link> */}
            {/* <Nav.Link as={NavLink} to="/predict" className="nav-link-custom">Predict</Nav.Link> */}
            {/* <Nav.Link as={NavLink} to="/umami-predictor" className="nav-link-custom">Search</Nav.Link> */}
            <Nav.Link as={NavLink} to="/how-to-use" className="nav-link-custom">🛠 How to Use </Nav.Link>
            <Nav.Link as={NavLink} to="/contact" className="nav-link-custom">📩 Contact Us </Nav.Link>
            {/* <Nav.Link as={NavLink} to="/umami-predictor" className="nav-link-custom">UmamiDB Predictor</Nav.Link> */}
            <Nav.Link href="https://cosylab.iiitd.edu.in/" className="nav-link-custom" target="_blank" rel="noopener noreferrer">
              <img
                src={logo}
                alt="CoSyLab"
                width="30"
                height="30"
              />
              &nbsp;CoSyLab
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavigationBar;